export default __webpack_public_path__ + "static/media/element_52.d380e125.webp";